import React from 'react';
import PropTypes from 'prop-types';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import ColumnLists from './c/columnLists/ColumnListsConnector';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

class ColumnListsSlidingPanel extends React.Component {
  state = {
    showColumnLists: false,
    showConfirmationDialog: false
  };

  componentDidMount() {
    this.props.mappingActions.loadMappedFields();
  }

  handleCloseMapping = () => this.setState({ showColumnLists: false });

  handleMapColumnsClick = () => {
    this.props.mappingActions.loadMappedFieldsInDivision(this.props.activeDivision);
    this.props.mappingActions.loadMappedFields();
    this.setState({ showColumnLists: true });
  };

  handleResetAllColumnsClick = () => {
    this.props.mappingActions.resetMappedFieldsInDivision(this.props.activeDivision);
    this.props.targetFieldsActions.enableMappedTargetField(this.props.tempMappedFieldsInDivision);
  };

  handleSaveClick = () => {
    this.props.mappingActions.addDivisionMapToMapping(this.props.activeDivision);
    this.handleCloseMapping();
  };

  render() {
    const { showColumnLists, currentDivision } = this.props;
    return (
      <span>
        <div className="map-columns__subgroup-section" style={ { display: 'flex', justifyContent: 'space-between' } }>
          <h4>3. Map Columns</h4>
          <SovosButtonsGroup align={ 'right' } >
            <SovosRaisedButton onClick={ this.handleMapColumnsClick } color="secondary" disabled={ !currentDivision || !showColumnLists } >MAP COLUMNS</SovosRaisedButton>
          </SovosButtonsGroup>
        </div>
        <SovosEditableSlidingPanel
          isDirty={ () => true }
          open={ this.state.showColumnLists }
          onClose={ this.handleCloseMapping }
          baseWidth={ '1080px' }
          title={ `Map Columns - ${ currentDivision ? currentDivision.substring(0, 28) : '' }` }
          SaveButtonProps={ {
            children: "UPDATE",
            onClick: this.handleSaveClick,
            className: 'map-columns__button'
          } }
          CancelButtonProps={
            {
              className: 'map-columns__button',
              children: 'CANCEL'
            }
          }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
          additionalButtons={ [
            <SovosRaisedButton
              key={ 'column-reset-all' }
              color="secondary"
              onClick={ this.handleResetAllColumnsClick }
              className="map-columns__wide-button"
            >
              RESET ALL COLUMNS
            </SovosRaisedButton> 
          ] }
        >
          <ColumnLists/>
        </SovosEditableSlidingPanel>
      </span>
    );
  }
}

ColumnListsSlidingPanel.propTypes = {
  activeDivision: PropTypes.number,
  showColumnLists: PropTypes.bool.isRequired,
  mappingInfo: PropTypes.arrayOf(PropTypes.object),
  tempMappedFieldsInDivision: PropTypes.arrayOf(PropTypes.object),
  currentDivision: PropTypes.string.isRequired,
  mappingActions: PropTypes.shape({
    resetMappedFieldsInDivision: PropTypes.func,
    loadMappedFieldsInDivision: PropTypes.func,
    loadMappedFields: PropTypes.func,
    addDivisionMapToMapping: PropTypes.func
  }).isRequired,
  targetFieldsActions: PropTypes.shape({
    enableMappedTargetField: PropTypes.func
  }).isRequired
};

ColumnListsSlidingPanel.defaultProps = {
  activeDivision: 0,
  currentDivision: ''
};

export default ColumnListsSlidingPanel;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/columnListsSlidingPanel/ColumnListsSlidingPanel.js